import { render, staticRenderFns } from "./UCIrvineELN4OIProcedure3.vue?vue&type=template&id=66d16245&scoped=true&"
import script from "./UCIrvineELN4OIProcedure3.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineELN4OIProcedure3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d16245",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
